import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
 

const AppPromoSection = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <section className="appcontainer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div
              className="appwrap lazy"
             style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/app-bg.webp)` }}

            >
              <div className="appimg" data-aos="fade-up" data-aos-duration="500">
                <img src={process.env.PUBLIC_URL + "/images/app-m.webp"} alt="App Mobile Preview" />
              </div>
              <div className="appcontent" data-aos="fade-right" data-aos-duration="500">
                <h2>Our Mobile App Is on Its Way</h2>
                <p>
                  We're building a GuestLinkup app so you can browse and book Himalayan homestays
                  even faster — with app-only deals when it launches.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppPromoSection;
